import React from 'react';
import ToolbarOrgLogo from './ToolbarOrgLogo.jsx';
import Avatar from 'housecall-ui/dist/DesignSystem/DataDisplay/Avatar/Avatar';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import ArrowDropdownIcon from 'housecall-ui/dist/IconsAndImages/Icons/ArrowDropdown';
import Tooltip from 'housecall-ui/dist/DesignSystem/DataDisplay/Tooltips/Tooltip';

function FranchiseMenuIcon({ classes, franchisee, handleNavMenuClick }) {
  return (
    <Tooltip title={franchisee.company_name}>
      <Button
        onClick={(event) => {
          handleNavMenuClick(event);
        }}
      >
        {franchisee.thumb_logo_url ? (
          <ToolbarOrgLogo orgLogoUrl={franchisee.thumb_logo_url} href={null} />
        ) : (
          <Avatar src={franchisee.thumb_logo_url}>
            {franchisee.thumb_logo_url ? null : franchisee.company_name.slice(0, 1)}
          </Avatar>
        )}
        <ArrowDropdownIcon />
      </Button>
    </Tooltip>
  );
}

export default React.memo(FranchiseMenuIcon);
